/**
 * Reads a stored filter as the list it may or may not already be. A scalar can still turn up —
 * a link or a persisted bag written before these filters became multi-value — and an unset filter
 * is an empty list.
 */
export function asList<T>(value: T | T[] | undefined): T[] {
  if (value === undefined) return [];

  return Array.isArray(value) ? value : [value];
}

/**
 * The form a multi-value filter takes on the query string: always a list, serialized by
 * `Http.getSearchParams` as repeated `key[]`, one value or several. Nothing selected is not a
 * filter at all — it must be `undefined` rather than `[]`, or `hasActiveFilters` reads the empty
 * list as a narrowed dashboard.
 */
export function toWireValue<T>(values: T[] | undefined): T[] | undefined {
  return values === undefined || values.length === 0 ? undefined : values;
}

/**
 * What an analytics event reports for a filter it declares as one string: the values joined by a
 * comma, so a single value is reported exactly as it always was. Nothing selected is `undefined`.
 */
export function joinValues(value: string | string[] | undefined): string | undefined {
  const values = asList(value);

  return values.length > 0 ? values.join(',') : undefined;
}
